import { BoutonFiltreFaq } from '@components/bouton-filtre-faq/models/bouton-filtre-faq';
import { Block } from '@shared/models';

export const boutonFiltreFaqMock = (faqListUrl?: string): Block<BoutonFiltreFaq> => ({
  type: 'bouton-filtre-faq',
  data: { faqListUrl },
});
